// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__1R-V-","errorLogs":"styles_errorLogs__1Qawn"};